import DocsText from '../../../text/docs/DocsText';
import DocsButtons from './DocsButtons';
import DocsCards from './DocsCards';
import DocsForms from './DocsForms';
import DocsHeaders from './DocsHeaders';
import DocsIcons from './DocsIcons';
import DocsLists from './DocsLists';
import DocsMedia from './DocsMedia';
import DocsMenus from './DocsMenus';
import DocsModals from './DocsModals';
import DocsThemes from './DocsThemes';

export {
  DocsButtons,
  DocsCards,
  DocsForms,
  DocsHeaders,
  DocsIcons,
  DocsLists,
  DocsMedia,
  DocsMenus,
  DocsModals,
  DocsText,
  DocsThemes,
};
